import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function YogurtBoomPortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-pink-200 selection:text-pink-900">
      <title>Yogurt Boom | De Heladería a Lovemark Internacional | Mood Agency</title>
      <meta name="description" content="Caso de éxito Yogurt Boom: Consolidación de marca y expansión internacional de franquicias mediante estrategias de marketing digital y conexión emocional." />
      <meta name="keywords" content="Yogurt Boom, franquicias, marketing digital, lovemark, heladería, expansión internacional, branding, estrategia de contenidos" />
      
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        {/* Background Ripple Effect - Pink/Colorful Theme */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-pink-200 via-pink-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-pink-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-pink-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-pink-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            YOGURT BOOM
          </h1>
          
          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            De heladería local a Lovemark Internacional: Una historia de expansión dulce y estratégica.
          </p>
        </div>
      </section>

      {/* Key Metrics */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">+94K</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Seguidores</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">13</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Sucursales (VEN & PAN)</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">+870K</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Likes</p>
          </div>
        </div>
      </section>

      {/* The Context */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Yogurt Boom, pionera en el concepto de heladería de real yogurt y autoservicio en Maracaibo, buscaba expandirse. Con 5 años en el mercado, el reto era consolidarse como la primera opción ante la creciente competencia y conectar emocionalmente con sus consumidores para abrirse paso en nuevos territorios.
          </p>
        </div>
      </section>

      {/* The Challenge */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Dulce<br/>Expansión
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              Para cubrir de su dulce sabor a más territorios, Yogurt Boom necesitaba consolidarse como la primera alternativa para el público. Destacar ante los competidores que surgieron posteriormente y mantener la esencia de la marca mientras se cruzaban fronteras fue el desafío principal.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-pink-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Diferenciación</h3>
              <p className="font-sans text-gray-500">Destacar ante la competencia con una propuesta de valor única y reconocible.</p>
            </div>
            <div className="border-l border-pink-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Conexión Emocional</h3>
              <p className="font-sans text-gray-500">Crear vínculos reales con los "Boomakers" a través de contenido y activaciones.</p>
            </div>
            <div className="border-l border-pink-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Inteligencia de Datos</h3>
              <p className="font-sans text-gray-500">Entender el comportamiento de compra para optimizar la comunicación y ventas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-pink-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Marketing de Contenidos</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Implementamos estrategias de contenido y promociones diseñadas específicamente para diferentes segmentos, creando vínculos emocionales y un alto engagement.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-pink-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Activaciones BTL</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Campañas como "Cupido Boom" y activaciones en punto de venta que integran la experiencia digital con la física, fortaleciendo la comunidad de Boomakers.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-pink-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Data Analytics</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Procesamos datos de compra (género, edad, ticket medio) para determinar los mejores momentos de consumo y dirigir la comunicación de forma certera.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Resultados</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "Yogurt Boom pasó de ser una marca precursora a convertirse en una verdadera lovemark en ascenso, con 11 sucursales en Venezuela y 2 en Panamá, respaldada por una comunidad digital vibrante."
            </p>
            <div className="w-20 h-1 bg-pink-500 mx-auto opacity-80"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
